var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-list',{ref:"EXTERNAL",attrs:{"list":_vm.list,"columns":_vm.columns,"export-data-options":_vm.exportDataOptions,"dataMapper":_vm.listDataMapper}})
}
var staticRenderFns = []

export { render, staticRenderFns }